module.exports = __webpack_public_path__ + "img/no-company-logo.151b615a.jpg";